import React from "react";

type Props = { className?: string; size?: "compact" | "full"; onDark?: boolean };

/**
 * KIBA Labs logo — yellow K icon + white wordmark on transparent background.
 * Always place this on dark (navy) surfaces. onDark=true → no filter (default).
 * onDark=false → brightness(0) makes it all-black for use on light surfaces.
 */
export default function Logo({ className = "", size = "full", onDark = true }: Props) {
  const h = size === "compact" ? 28 : 34;
  return (
    <div className={`inline-flex items-center select-none ${className}`} data-testid="kiba-logo" aria-label="KIBA Labs">
      <img
        src="/kiba-logo-yellow-k.png"
        alt="KIBA Labs"
        draggable={false}
        style={{
          height: h,
          width: "auto",
          display: "block",
          filter: onDark ? "none" : "brightness(0) saturate(100%)",
        }}
      />
    </div>
  );
}
